import React, { useRef, useState, useEffect } from 'react';
import { FixedSizeList as List } from 'react-window';
import { useWindowResize } from 'utils/useWindowResize';
import TableRow from './TableRow';

const ITEM_HEIGHT = 36;

const Row = ({
	data,
	index,
	companies,
	spendFormatter,
	showCompanySpend,
	onRemove,
	onInputChange,
	currencySymbol,
	wacc,
	itemsType,
	fullData,
	segments,
	showTopVendors,
}) => {
	const rowData = data[index];
	const originalData =
		fullData && fullData.find(item => item.name === rowData.name);

	return (
		<TableRow
			data={data[index]}
			companies={companies}
			spendFormatter={spendFormatter}
			showCompanySpend={showCompanySpend}
			onRemove={onRemove}
			onInputChange={onInputChange}
			currencySymbol={currencySymbol}
			itemsType={itemsType}
			wacc={wacc}
			originalData={originalData}
			segments={segments}
			showTopVendors={showTopVendors}
		/>
	);
};

export const VirtualList = ({
	data,
	companies,
	spendFormatter,
	showCompanySpend,
	onRemove,
	onInputChange,
	currencySymbol,
	headerRef,
	wrapperRef,
	itemsType,
	wacc,
	fullData,
	segments,
	showTopVendors,
}) => {
	const listOuterRef = useRef();
	const [height, setHeight] = useState(0);
	const [, windowHeight] = useWindowResize();

	useEffect(
		() => {
			if (wrapperRef && wrapperRef.current) {
				setHeight(wrapperRef.current.clientHeight);
			}
		},
		[wrapperRef, windowHeight]
	);

	useEffect(
		() => {
			const headerEl = headerRef.current;
			const listEl = listOuterRef.current;

			if (headerEl && listEl) {
				listEl.addEventListener(
					'scroll',
					e => {
						headerEl.scrollLeft = e.target.scrollLeft;
					},
					{ passive: true }
				);
			}
		},
		[headerRef, listOuterRef]
	);

	return (
		<List
			outerRef={listOuterRef}
			height={height}
			width="100%"
			itemCount={data.length}
			itemSize={ITEM_HEIGHT}
			itemData={data}
			style={{ overflow: 'auto overlay' }}
		>
			{({ data, index, style }) => (
				<div style={style}>
					<Row
						data={data}
						index={index}
						wacc={wacc}
						itemsType={itemsType}
						companies={companies}
						spendFormatter={spendFormatter}
						showCompanySpend={showCompanySpend}
						onRemove={onRemove}
						onInputChange={onInputChange}
						currencySymbol={currencySymbol}
						fullData={fullData}
						segments={segments}
						showTopVendors={showTopVendors}
					/>
				</div>
			)}
		</List>
	);
};
